import { Images } from "../assets/images";

const settings = {
  isSplash: false,
};

//Home Page
const greeting = {
  title: "We Make Amazing Digital Products for Your Business",
  logo_name: "Coding Cogs",
  subTitle:
    "We're an enthuastic & passionate freelancers with a keen interest to learn new technologies as well as improve our skills",
  resumeLink:
    "https://drive.google.com/file/d/1FL_wydnPF2SWCdw2goYAgZ1KKBx8TpcD/view?usp=sharing",
};

const skills = {
  data: [
    {
      title: "Machine Learning",
      lottieAnimation: "/lottie/ai.json",
      image: "/image/ai.png",
      skills: [
        "⚡ Data preprocessing and cleaning to prepare datasets for model training",
        "⚡ Deploying machine learning models in production environments using technologies like Docker, Kubernetes, and Flask",
      ],
      softwareSkills: [
        {
          skillName: "Python",
          fontAwesomeClassname: "vscode-icons:file-type-python",
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "logos:java",
        },
        {
          skillName: "TensorFlow",
          fontAwesomeClassname: "logos:tensorflow",
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos:pytorch-icon",
        },
      ],
    },
    {
      title: "Mobile Application",
      lottieAnimation: "/lottie/mobile.json",
      image: "/image/mobile.png",
      skills: [
        "⚡ Developing mobile applications using frameworks like React Native, Flutter or Java",
        "⚡ Building intuitive user interfaces and experiences that are optimized for mobile devices",
        "⚡ Implementing features such as push notifications, geolocation, and camera integration",
      ],
      softwareSkills: [
        {
          skillName: "React Native",
          fontAwesomeClassname: "vscode-icons:file-type-reactts",
        },
        {
          skillName: "Flutter",
          fontAwesomeClassname: "logos:flutter",
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "logos:java",
        },
        {
          skillName: "App Store",
          fontAwesomeClassname: "logos:apple-app-store",
        },
      ],
    },

    {
      title: "Web Application",
      lottieAnimation: "/lottie/Web.json",
      image: "/image/web.png",
      skills: [
        "⚡ Integrating with databases like MongoDB, MySQL, or PostgreSQL to store and manage application data",
        "⚡ Implementing features such as authentication, authorization, and payment gateways",
        "⚡ Deploying web applications to production environments using cloud services like AWS, Azure, or Google Cloud",
      ],
      softwareSkills: [
        {
          skillName: "React",
          fontAwesomeClassname: "logos:react",
        },
        {
          skillName: "Vue",
          fontAwesomeClassname: "logos:vue",
        },
        {
          skillName: "Angular",
          fontAwesomeClassname: "logos:angular-icon",
        },
        {
          skillName: "Node.js",
          fontAwesomeClassname: "logos:nodejs-icon",
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "logos:java",
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "logos:mysql",
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "logos:docker-icon",
        },
      ],
    },
    {
      title: "Desktop Application",
      lottieAnimation: "/lottie/Desk.json",
      image: "/image/desktop.png",
      skills: [
        "⚡ Designing highly attractive user interface for desktop applications",
        "⚡ Customizing logo designs and building logos from scratch",
        "⚡ Creating the flow of application functionalities to optimize user experience",
      ],
      softwareSkills: [
        {
          skillName: "C Sharp",
          fontAwesomeClassname: "devicon:csharp",
          style: {
            color: "#FF2BC2",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "logos:java",
          style: {
            color: "#F24E1E",
          },
        },
        {
          skillName: "Ruby",
          fontAwesomeClassname: "logos:ruby",
          style: {
            color: "#FF7C00",
          },
        },
        {
          skillName: "kotlin",
          fontAwesomeClassname: "devicon:kotlin",
          style: {
            color: "#000000",
          },
        },
      ],
    },
  ],
};

// contributors
const contributors = [
  {
    style: {
      color: "#F79F1B",
    },
    profileLink: Images.Nishan,
  },
  {
    style: {
      color: "#2EC866",
    },
    profileLink: Images.Person,
  },
  {
    style: {
      color: "#5B4638",
    },
    profileLink: Images.Person2,
  },
  {
    style: {
      color: "#1F8ACB",
    },
    profileLink:
      "https://st3.depositphotos.com/6672868/13701/v/600/depositphotos_137014128-stock-illustration-user-profile-icon.jpg",
  },
];

const projects = [
  {
    title:
      "Multimodal Real-Time Pedestrian Detection using Radar-Camera Fusion  with 3-D Clustering Techniques",
    subtitle: "Machine Learning",
    logo_path:
      "https://upload.wikimedia.org/wikipedia/commons/d/d5/Hey_Machine_Learning_Logo.png",
    descriptions: [
      "⚡ The design and development of autonomous vehicles aim to ensure safe road navigation by continuously monitoring the environment, focusing on pedestrian detection systems.  The ability to quickly and accurately detect people is crucial. However, it is essential to  consider the challenges posed by pedestrian detection, such as variations in skin color  due to lighting, race, and imaging conditions. It presents a difficult task as human skin  detection has not been thoroughly studied in this context. Many studies neglect to  address this systematically regarding pedestrian detection systems for autonomous cars.  We are employing a Radar-Camera fusion technique that accurately predicts obstacles in  different lighting conditions to address this challenge. ",
    ],
    website_link: "https://doi.org/10.1117/12.2619013",
  },
  {
    title:
      "Improvement of Vehicles Accident Detection using Object Tracking with U Net",
    subtitle: "Machine Learning",
    logo_path:
      "https://intellisee.com/wp-content/uploads/2022/05/vehicle-icon-1-300x300-1.png",
    descriptions: [
      "⚡ The increased use of CCTV cameras has led to a surge in surveillance footage, making it  essential to detect accidents in real-time streams. The detection of accidents is  challenging due to various anomalous events and objects in the frame. Researchers have  proposed various methods to detect anomalies, including multimodal techniques and  image reconstruction, but none have applied frame reconstruction with object tracking  (OT). This study focuses on road accident detection using a combination of OT and image  reconstruction using a u-net autoencoder with multiple variants. The background  removal techniques are applied to reduce background variability, followed by image  reconstruction and object detection using YOLOv4 and object tracking using DeepSort.  The Mahalanobis distance and the reconstruction error are determined, and the  combination of these two errors is used to determine if the frame is an accident. The u net with skip connections and the OT algorithm achieved the highest accuracy in the  proposed model.",
    ],
    website_link: "",
  },
  {
    title:
      "Predicting the Power Consumption of the Electric Vehicles Considering End User Inputs of the Charging Station",
    subtitle: "Machine Learning",
    logo_path: "https://cdn-icons-png.flaticon.com/512/4514/4514985.png",
    descriptions: [
      "⚡ The analysis of EV charging data from Schneider Electric from 2017 to 2020 was  conducted through feature engineering selection, including a correlation test and  PCA. The cleaned data were then analyzed to identify problems within the grid and  provide a solution. To simplify the analysis, the power consumption of vehicles during  charging was evenly distributed over the total charging time. A Dynamic Load  Management with a Scheduling model was proposed to address peak power  consumption and minimize its impact on the grid.",
    ],
    website_link:
      "https://github.com/KrishArul26/Analysis-of-Charging-Schedules-of-Electric Vehicles-Considering-End-User-Inputs-.git",
  },
  {
    title:
      "Autonomous Vehicle Running with Line Navigation and Object Detection  Using OpenCV and AI Techniques - Live Streaming. ",
    subtitle: "Machine Learning",
    logo_path:
      "https://banner2.cleanpng.com/20180608/elv/kisspng-car-gps-navigation-systems-vehicle-tracking-system-5b1a26a490d8c7.7632618615284404845933.jpg",
    descriptions: [
      "⚡ Mobility on a wide scale is moving towards complete automation. Though the  technology for automating vehicles already exists, these technologies must be  optimized to fit the current environment. This project would be a scaled-down model  of the Autonomous Car and focus on the live streaming lane detection using OpenCV. ",
    ],
    website_link:
      "https://github.com/KrishArul26/Live-streaming-Autonomous-Vehicle running-With-line-detection-using-OpenCV.git ",
  },
  {
    title: " IoT Based on Remote Sensor Data Monitoring and Actuator Control",
    subtitle: "Machine Learning",
    logo_path: "https://cdn-icons-png.flaticon.com/512/6119/6119533.png",
    descriptions: [
      "⚡ The objective of this project was to create an affordable and user-friendly partial  open-source monitoring system that could be customized according to the customer's  needs. The current housing systems are becoming more automated, but the existing  solutions in the market are complex and expensive. The project prototype focused on  monitoring a home water tank and was built with the following components:",
      "⚡ DHT11 sensor for temperature and humidity readings.",
      "⚡ A water level sensor for emergency stop once the desired level is reached.",
      "⚡ MQTT protocol was used for communication between the water level sensor  and the relay.",
      "⚡ Raspberry Pi Zero modules were used to handle sensor data, and Raspberry Pi  4 was used to request data from MQTT and control the relay and power.",
      "⚡ InfluxDB stores the water level and DHT11 sensor streaming time-series data.",
      "⚡ HiveMQ broker was used to testing client-published/subscribed messages.",
      "⚡ Grafana was used to visualize temperature and humidity data.",
    ],
    website_link:
      "https://github.com/KrishArul26/IOT-BASED-REMOTE-SENSOR-DATA MONITORING-AND-ACTUATOR-CONTROL.git",
  },
  {
    title: "Multimodal approach for classifying road accident severity",
    subtitle: "Machine Learning",
    logo_path: "https://www.pngmart.com/files/22/Car-Crash-Transparent-PNG.png",
    descriptions: [
      "⚡ It aims to classify the severity of road traffic accidents using a combination of machine learning  (ML) and deep learning (DL) techniques. The K-Nearest Neighbors algorithm was used to handle  missing values, and encoding and hyperparameter tuning methods were applied to convert  categorical data and optimize parameters. Various statistical methods were also used to address  imbalances and non-values in the dataset. The ML models developed include Random Forest,  XGBoosting, and LightGBM, while the deep learning model was optimized using hyperparameter  techniques. The accuracy and precision values of the models were used as metrics to select the  best model.",
    ],
    website_link: "",
  },
];

// Projects Page
const projectsHeader = {
  title: "Our Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them to web applications using cloud infrastructure.",
};

export const BREAKPOINTS = {
  xs: 360,
  sm: 568,
  md: 768,
  lg: 992,
  xl: 1280,
  xxl: 1920,
} as const;

const getMedia = <T extends number>(breakpoint: T): `(min-width: ${T}px)` =>
  `(min-width: ${breakpoint}px)`;

export const media = {
  xs: getMedia(BREAKPOINTS.xs),
  sm: getMedia(BREAKPOINTS.sm),
  md: getMedia(BREAKPOINTS.md),
  lg: getMedia(BREAKPOINTS.lg),
  xl: getMedia(BREAKPOINTS.xl),
  xxl: getMedia(BREAKPOINTS.xxl),
};

export { settings, greeting, skills, projects, projectsHeader, contributors };
